import React from 'react';
import RadioFilter from './RadioFilter';

export default function OrderRadioFilter() {
  return (
    <RadioFilter
      title="Ordenar por"
      ariaLabel="Ordenar por"
      showDivider={true}
    />
  );
}



// WEBPACK FOOTER //
// ./src/views/v2/search/components/filter/components/OrderRadioFilter.jsx